import React from 'react';
import ReactDOM from 'react-dom';
import logo from './logo.svg';
import './App.css';
import Listitem from './Listitem';
import { library } from '@fortawesome/fontawesome-svg-core';
import {faTrash} from '@fortawesome/free-solid-svg-icons';

library.add(faTrash);

class  App extends React.Component {

  constructor(props)
  {
    super(props)
    this.state={
      items:[],
      currentItem:{
        text:'',
        key:''
      }

    }
  }

  handleInput=(e)=>{
    this.setState({
      currentItem:{
        text:e.target.value,
        key:Date.now()
      }
    })

  }

  addItem=(e)=>{
   e.preventDefault();
   const newItem=this.state.currentItem
   //console.log(newItem)
   if(newItem.text!==""){
     const newItems=[...this.state.items,newItem];
    // console.log(items)
    this.setState({
      items:newItems,
      currentItem:{
        text:'',
        key:''
      }
    })
   }
   
}


  deleteItem=(key)=>{
  const filteritems=this.state.items.filter(item=>item.key!==key);
  this.setState({
    items:filteritems
  })
  }

  setUpdate=(text,key)=>{

   const items=this.state.items;
   items.map(item=>{
  if(item.key===key)
  {
    item.text=text;
  }
})
  this.setState({
    items:items
 
})

  }


  render(){

  
  return (
  
   <div className="App">
   <header>
   <form id="to-do-form" onSubmit={this.addItem}>
   <input type="text" placeholder="scheduler"
   value={this.state.currentItem.text} 
   onChange={this.handleInput }
   
   />

   <button type="submit">Add</button>
   
   </form> 
</header>
<Listitem items={this.state.items}
  deleteItem={this.deleteItem}
  setUpdate={this.setUpdate}
></Listitem>
   </div>
  );
  }
}

export default App;
